import { Button } from '@repo/go-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { RefObject, PropsWithChildren } from 'react';

import styles from './combobox-dropdown.module.scss';

type Props = PropsWithChildren<{
  parentElement?: RefObject<HTMLDivElement>;
  onButtonClick: VoidFunction;
  onClose?(): void;
}>;

export const ComboboxDropdown = wrap<Props>(function ComboboxDropdown({
  children,
  parentElement,
  onButtonClick,
  onClose,
}) {
  const { t } = useTranslation();

  const handleClick = () => {
    onButtonClick();
    onClose?.();
  };

  useEffect(() => {
    const element = parentElement?.current;

    if (!element) {
      return;
    }

    const testClb = (entries: IntersectionObserverEntry[]) => {
      if (!entries[0].isIntersecting) {
        onClose?.();
      }
    };

    const test = new IntersectionObserver(testClb);

    test.observe(element);

    return () => {
      test.disconnect();
    };
  }, [parentElement, onClose]);

  return (
    <>
      {children}

      <Button variant="flat" className={styles.button} onClick={handleClick}>
        {t('directory:components.addNewDirectoryButton')}
      </Button>
    </>
  );
});
